import React from 'react';
import { observer } from 'mobx-react';
import {
	OutlookMessageMode,
} from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import {
	CommandBar,
	ICommandBarItemProps,
} from '@fluentui/react/lib/CommandBar';

import { CommandButton, IconButton } from '@fluentui/react';
import { MobileAttachmentsState } from './MobileAttachments';

export interface IOutlookItemCommandBarProps {
	state: MobileAttachmentsState;
}

class OutlookItemCommandBar extends React.Component<
	IOutlookItemCommandBarProps,
	{}
> {
	componentDidMount(): void {
		this.props.state.loadCurrentMessageProps();
	}

	render(): React.ReactNode {


		let commandBarItems: ICommandBarItemProps[] = [];
		let farCommandBarItems: ICommandBarItemProps[] = [];

		this.props.state.userConfig.entityTypes.getUserAccessibleEntityTypes(true).forEach(entityType => {

			let options = [];

			if(entityType.outlookEnableCreateNewOption) {
				options.push({
					key: entityType.id,
					text: 'New ' + (entityType.singularName || entityType.pluralName),
					iconProps: { iconName: 'Add' },
					onClick: (_:any, item:any) => {
						if(item) {
							this.props.state.showCreateEntityDialog(entityType);
						}
					},
				});
			}

			if(entityType.outlookEnableViewAllOption) {
				options.push({
					key: entityType.id,
					text: 'View all ' + (entityType.pluralName || entityType.singularName),
					iconProps: { iconName: 'CheckListText' },
					onClick: (_:any, item:any) => {
						if(item) {
							this.props.state.showViewAllEntityDialog(entityType);
						}
					},
				});
			}

			if(options.length > 0) {
				commandBarItems.push({
					key: entityType.id,
					text: entityType.pluralName || entityType.singularName,
					subMenuProps: {
						items: options
					}
				});
			}
		});

		

		if (this.props.state.mode === OutlookMessageMode.Compose) {
			
		} else if (this.props.state.hasBeenFiled) {

			
			/*
			farCommandBarItems.push({
				key: 'msgCmdFiledIcon',
				commandBarButtonAs: () => {
					return (
						<div style={{ marginTop: 5, marginRight:5, marginLeft:5, cursor:'help' }} title={}>
							<Stack horizontal>
								<StatusIndicator
									status="Filed"
									type={StatusIndicatorType.BadgeSmall}
									config={[]}
								/>
							</Stack>
						</div>
					);
				},
			});
			
			
			*/
		}

		farCommandBarItems.push({
			key: 'advancedFileSearchCommand',
			commandBarButtonAs: () => <CommandButton
				text='Files'
				label='Files'
				iconProps={{ iconName: 'DocumentSearch' }}
				title="Launch the advanced document search"
				ariaLabel="Launch the advanced document search"
				onClick={() => {
					this.props.state.commands.launchWindow(`/#home`);
				}}
			/>
		});
		
		farCommandBarItems.push({
			key: 'refreshCommand',
			commandBarButtonAs: () => <CommandButton
				iconProps={{ iconName: 'Refresh' }}
				title="Refresh"
				ariaLabel="Refresh"
				onClick={() => {
					window.location.reload();
				}}
				/>
		});

		if(this.props.state.userConfig.isAdmin) {
			farCommandBarItems.push({
				key: 'settingsCommand',
				commandBarButtonAs: () => <IconButton
					iconProps={{ iconName: 'Settings' }}
					title="Launch admin settings"
					ariaLabel="Launch admin settings"
					onClick={() => {
						let location = window.location.origin;
						this.props.state.commands.launchWindow(`${location}`);
					}}
					/>
			});
		}


		if (commandBarItems.length === 0 && farCommandBarItems.length === 0) {
			return <></>;
		}

		return (<CommandBar items={commandBarItems} farItems={farCommandBarItems}></CommandBar>);
	}
}

export default observer(OutlookItemCommandBar);
